// Hover-value mapping, replicating Skysight's exact algorithm (verified from
// their bundle): the vector-tile feature carries only `idx` (a quantized bin),
// and the displayed value is the MIDPOINT between adjacent boundary values at
// that idx. The boundary values ("plot values") are the legend stops; the top
// bin clamps to ">max". Units are appended with no space, matching Skysight
// (e.g. "2300m", "0.75m/s").

const round2 = (n) => Math.round(n * 100) / 100;

// Legend stops are stored high→low (e.g. ">4400" … "200"); plot values ascend.
// ">"/"<" prefixes and any stray spaces are stripped to a number.
export const overlayPlotValues = (overlay) =>
  overlay.legend.stops
    .map((s) => parseFloat(String(s.label).replace(/[><\s]/g, '')))
    .filter((n) => Number.isFinite(n))
    .reverse();

export const overlayValueLabel = (overlay, idx) => {
  if (!overlay || idx == null || Number.isNaN(idx)) return '';
  const pv = overlayPlotValues(overlay);
  if (pv.length === 0) return '';
  const unit = overlay.legend.unit || '';
  const re = Math.max(0, Math.round(idx));
  if (re >= pv.length - 1) return `>${round2(pv[pv.length - 1])}${unit}`;
  return `${round2((pv[re] + pv[re + 1]) / 2)}${unit}`;
};
